<template>
    <el-dialog :visible.sync="openDialog" width="800px" :title="title" :close-on-click-modal="false">
        <el-form label-width="100px" ref="form" :model="form" :rules="rules" size="small">
            <el-row>
                <el-col :span="12">
                    <el-form-item label="物料编码" prop="code">
                        <el-input v-model="form.code" placeholder="请输入物料编码"/>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="物料名称" prop="name">
                        <el-input v-model="form.name" placeholder="请输入物料名称"/>
                    </el-form-item>
                </el-col>
                <el-col :span="12" style="height: 32px;">
                    <el-form-item label="物料分类" prop="classifyId">
                        <!-- <el-input v-model="form.classifyId" placeholder="请输入物料分类"/> -->
                        <treeselect
                            v-model="form.classifyId"
                            size="mini"
                            :show-count="true"
                            :options="optionMenus"
                            :normalizer="normalizer"
                            placeholder="请选择物料分类"
                        />
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="规格" prop="sspace">
                        <el-input v-model="form.sspace" placeholder="请输入规格"/>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="型号" prop="model">
                        <el-input v-model="form.model" placeholder="请输入型号"/>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="图号" prop="figueNumber">
                        <el-input v-model="form.figueNumber" placeholder="请输入图号"/>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="计量单位" prop="unit">
                        <el-input v-model="form.unit" placeholder="请输入计量单位"/>
                    </el-form-item>
                </el-col>
                <!-- <el-col :span="12">
                    <el-form-item label="状态" prop="status">
                        <el-radio-group v-model="form.status">
                            <el-radio :label="0">启用</el-radio>
                            <el-radio :label="1">停用</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </el-col> -->
            </el-row>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button @click="openDialog = false" size="small">取 消</el-button>
            <el-button type="primary" @click="submitForm" size="small">确 定</el-button>
        </span>
    </el-dialog>
</template>
<script>
import {
  commodityList,
  addCommodity,
  editCommodity,
  delCommodity,
  batchDelCommodity,
  exportCommodity,
} from '@/api/basic/commodity.js'
import { queryByParentId } from '@/api/basic/commodityClassification.js'
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
export default {
    components:{
        Treeselect
    },
    data(){
        return {
            title: "",
            openDialog: false,
            form: {},
            optionMenus: [],
            rules: {
                code: [{ required: true, message: '请输入物料编码', trigger: 'blur' }],
                name: [{ required: true, message: '请输入物料名称', trigger: 'blur' }],
                classifyId: [{ required: true, message: '请输入物料分类', trigger: 'blur' }],
                sspace: [{ required: true, message: '请输入规格', trigger: 'blur' }],
                model: [{ required: true, message: '请输入型号', trigger: 'blur' }],
                // figueNumber: [{ required: true, message: '请输入图号', trigger: 'blur' }],
                unit: [{ required: true, message: '请输入计量单位', trigger: 'blur' }],
                // status: [{ required: true, message: '请输入状态，0：不启用；1：启用', trigger: 'blur' }],
            }
        }
    },
    methods:{
        async getMenuData(callback){
            let _this = this;
            const { data: res } = await queryByParentId({});
            if (res.code == 0) {
                let nodes = res.data || [];
                // nodes.forEach((no)=>{
                //     no['name'] = '一级分类';
                // })
                if(callback){
                    callback(nodes)
                }
            }
        },
        normalizer(node) {
            //删除 数据的子集
            if (node.children && !node.children.length) {
                delete node.children;
            }
            return {
                id: node.id,
                //将name转换成必填的label键
                label: node.name,
                children: node.children
            };
        },
        /** 查询菜单下拉树结构 */
        getTreeselect() {
            let _this = this;
            _this.optionMenus = [];
            this.getMenuData((data)=>{
                let arr = [];
                if(data[0] && data[0].children){
                    arr = data[0].children
                }
                console.log(arr)
                data[0]['isDisabled'] = true;
                let newData = _this.$handleTree(arr, "id");
                console.log(newData)
                // _this.optionMenus.push(data[0]);
                _this.optionMenus=arr;
                // _this.optionMenus.push(arr);
            })
        },
         // 表单重置
        reset: function () {
            this.form = {
                id: undefined,
                code: undefined,
                name: undefined,
                classifyId: undefined,
                sspace: undefined,
                model: undefined,
                // figueNumber: undefined,
                unit: undefined,
                // status: 0,
                // createTime: undefined,
                // createUser: this.$store.getters['user/user'].id,
            }
            if (this.$refs["form"] !== undefined) {
                this.$refs["form"].resetFields();
            }
        },
        submitForm() {
            let _this = this;
            _this.$refs['form'].validate((valid) => {
                if (valid) {
                    let newForm = {
                        createUser: this.$store.getters['user/user'].id,
                        ..._this.form
                    }
                    if (_this.form.id != undefined) {
                        editCommodity(newForm).then(response => {
                            if (response.data.code === 0) {
                                _this.$success(response.data.msg);
                                _this.openDialog = false;
                                _this.$emit('callback',{type:'getlist'})
                            } else {
                                _this.$fail(response.data.msg);
                            }
                        });
                    } else {
                        addCommodity(newForm).then(response => {
                            if (response.data.code === 0) {
                                _this.$success(response.data.msg);
                                _this.openDialog = false;
                                _this.$emit('callback',{type:'getlist'})
                            } else {
                                _this.$fail(response.data.msg);
                            }
                        });
                    }
                }
            });
        },
    },
}
</script>
<style lang="sass" scoped>

</style>


